import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

const PageRenderer = ({ htmlContent }) => {
	const [currentTestimonial, setCurrentTestimonial] = useState(0);
	const [currentProduct, setCurrentProduct] = useState(0);
	const [currentSocialVideo, setCurrentSocialVideo] = useState(0);
	const [isHeaderVisible, setIsHeaderVisible] = useState(true);
	const [lastScrollY, setLastScrollY] = useState(0);
	const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
	const [lightboxOpen, setLightboxOpen] = useState(false);
	const [lightboxIndex, setLightboxIndex] = useState(0);
	
	const testimonials = [
		{
			title: "Functionality & Style",
			text: "Bought a pack of 3 to wear during the week.I love that the hairs don't stick into the fibers like on a standard tee, It's comfortable & stylish as well. Innovative!",
			author: "C.J."
		},
		{
			title: "Amazing Quality",
			text: "The fabric is incredibly durable and actually repels hair as advertised. My cleanup time has been cut in half. Highly recommend to any barber!",
			author: "Mike Johnson"
		},
		{
			title: "Worth Every Penny",
			text: "After trying countless alternatives, this is the only shirt that truly keeps hair off. The comfort level is outstanding too. A must-have for professionals.",
			author: "Sarah Williams"
		}
	];





	const galleryImages = [
		{ src: "/images/home/img_3990.jpg", title: "Bella's Premium Content" },
		{ src: "/images/home/img_4048.jpg", title: "Exclusive Access" },
		{ src: "/images/home/595DCC9D-067F-447F-9F95-BC294308E80C.JPEG", title: "Premium Beauty" },
		{ src: "/images/home/904F1292-0660-4ABD-B804-E564EA7F0835.jpeg", title: "Speed & Style" },
		{ src: "/images/home/ACC4E797-26D8-4190-9D9A-6873310507DE.jpg", title: "Classic Elegance" },
		{ src: "/images/home/dsc_8961 copy.jpg", title: "Modern Power" },
		{ src: "/images/home/5405F01F-C3B5-4893-AA6D-23AB20EC67F8.JPEG", title: "Raw Confidence" },
		{ src: "/images/home/dsc_9087 copy.jpg", title: "Elegant Beauty" },
		{ src: "/images/home/IMG_8296.jpg", title: "VIP Access" },
		{ src: "/images/home/9EF4C814-4C81-4FB6-9E29-9FE49A16AA32.jpg", title: "Night Sessions" },
		{ src: "/images/home/2CA78E38-0216-4ECB-AB2B-BC5D9C1695CD.jpg", title: "Track Days" },
	];

	const openLightbox = (index) => {
		setLightboxIndex(index);
		setLightboxOpen(true);
		document.body.style.overflow = 'hidden';
	};

	const closeLightbox = () => {
		setLightboxOpen(false);
		document.body.style.overflow = 'unset';
	};

	const nextImage = () => {
		setLightboxIndex((prev) => (prev + 1) % galleryImages.length);
	};

	const prevImage = () => {
		setLightboxIndex((prev) => (prev - 1 + galleryImages.length) % galleryImages.length);
	};

	const shareOnSocial = (platform) => {
		const url = encodeURIComponent(window.location.href);
		const title = encodeURIComponent('Check out Bella on RevvedNReady!');
		const imageUrl = encodeURIComponent(galleryImages[lightboxIndex].src);
		
		let shareUrl = '';
		switch(platform) {
			case 'twitter':
				shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${title}`;
				break;
			case 'facebook':
				shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
				break;
			case 'whatsapp':
				shareUrl = `https://wa.me/?text=${title}%20${url}`;
				break;
			case 'pinterest':
				shareUrl = `https://pinterest.com/pin/create/button/?url=${url}&media=${imageUrl}&description=${title}`;
				break;
		}
		window.open(shareUrl, '_blank', 'width=600,height=400');
	};

	useEffect(() => {
		const handleScroll = () => {
			const currentScrollY = window.scrollY;
			setIsHeaderVisible(currentScrollY < lastScrollY || currentScrollY < 100);
			setLastScrollY(currentScrollY);
		};

		const handleResize = () => {
			setIsMobile(window.innerWidth < 768);
		};

		const handleKeyPress = (e) => {
			if (!lightboxOpen) return;
			if (e.key === 'Escape') closeLightbox();
			if (e.key === 'ArrowLeft') prevImage();
			if (e.key === 'ArrowRight') nextImage();
		};

		window.addEventListener('scroll', handleScroll, { passive: true });
		window.addEventListener('resize', handleResize);
		window.addEventListener('keydown', handleKeyPress);
		
		// Handle hash navigation on page load (only once)
		const hash = window.location.hash.substring(1);
		if (hash) {
				setTimeout(() => {
				const element = document.getElementById(hash);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth', block: 'start' });
				}
			}, 100);
		}

		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleResize);
			window.removeEventListener('keydown', handleKeyPress);
		};
	}, [lightboxOpen]);

	const handlePrevious = () => {
		setCurrentTestimonial((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
	};

	const handleNext = () => {
		setCurrentTestimonial((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
	};

	const scrollToSection = (sectionId) => {
		// Check if we're on the home page
		const currentPath = window.location.pathname;
		if (currentPath === '/') {
			// On home page, scroll to section
			const element = document.getElementById(sectionId);
			if (element) {
				element.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		} else {
			// On a different page, navigate to home with hash
			window.location.href = `/#${sectionId}`;
		}
	};

	const getNavigationItems = () => {
		if (!htmlContent) return [];
		
		// Check if htmlContent is an array (category page) or an object (region page)
		const dataArray = Array.isArray(htmlContent) ? htmlContent : 
			htmlContent.pages_city || htmlContent.pages_state || htmlContent.pages_country || [];
		
		// If pages_state is available, show states
		if (htmlContent.pages_state) {
			const seenStates = new Set();
			return htmlContent.pages_state
				.filter(page => {
					if (!page.state?.state || seenStates.has(page.state.state)) {
						return false;
					}
					seenStates.add(page.state.state);
					return true;
				})
				.map(page => ({
					name: page.state.state,
					slug: page.url
				}));
		}

		// If pages_city is available, show cities
		if (htmlContent.pages_city) {
			const seenCities = new Set();
			return htmlContent.pages_city
				.filter(page => {
					if (!page.city?.city || seenCities.has(page.city.city)) {
						return false;
					}
					seenCities.add(page.city.city);
					return true;
				})
				.map(page => ({
					name: page.city.city,
					slug: page.url
				}));
		}
		
		// If pages_country is available (for category pages), show countries
		if (htmlContent.pages_country) {
			const seenCountries = new Set();
			return htmlContent.pages_country
				.filter(page => {
					if (!page.country?.country || seenCountries.has(page.country.country)) {
						return false;
					}
					seenCountries.add(page.country.country);
					return true;
				})
				.map(page => ({
					name: page.country.country,
					slug: page.url
				}));
		}
		
		// If we're viewing a city page or state page, extract the path parts
		const currentPath = window.location.pathname;
		const pathParts = currentPath.split('/').filter(Boolean);
		
		// If we're on a state page (united-states/california)
		if (pathParts.length === 2 && pathParts[0] === 'united-states') {
			// Show cities for this state
			const currentState = pathParts[1];
			const seenCities = new Set();
			return dataArray
				.filter(item => {
					const itemPathParts = item.url?.split('/').filter(Boolean);
					return itemPathParts?.[0] === 'united-states' && 
						   itemPathParts?.[1] === currentState &&
						   itemPathParts.length === 3 &&
						   !seenCities.has(itemPathParts[2]);
				})
				.map(item => ({
					name: item.url.split('/').pop(),
					slug: item.url
				}));
		}
		
		// If we're on the country page (united-states)
		if (pathParts.length === 1 && pathParts[0] === 'united-states') {
			// Show states
			const seenStates = new Set();
			return dataArray
				.filter(item => {
					const itemPathParts = item.url?.split('/').filter(Boolean);
					return itemPathParts?.[0] === 'united-states' &&
						   itemPathParts.length >= 2 &&
						   !seenStates.has(itemPathParts[1]);
				})
				.map(item => ({
					name: item.url.split('/')[1],
					slug: `/united-states/${item.url.split('/')[1]}`
				}));
		}
		
		// Default: show categories
		const seenCategories = new Set();
		return dataArray
			.filter(item => {
				if (!item.category?.name || seenCategories.has(item.category.name)) {
					return false;
				}
				seenCategories.add(item.category.name);
				return true;
			})
			.map(item => ({
				name: item.category.name,
				slug: item.url
			}));
	};

	const getPageTitle = () => {
		if (!htmlContent) return "Best Only Fans Creator";

		const path = window.location.pathname;
		const parts = path.split('/').filter(Boolean);
		const category = htmlContent.category?.name;
		
		console.log('Path parts:', parts);

		// Explicitly check URL patterns from most specific to least specific
		if (parts.length === 4 && htmlContent.city?.city) {
			// /country/state/city/category
			const state = htmlContent.city?.state?.state || htmlContent.state?.state;
			return `${category} in ${htmlContent.city.city}, ${state}`;
		}
		
		if (parts.length === 3 && htmlContent.state?.state) {
			// /country/state/category
			return `${category} in ${htmlContent.state.state}`;
		}
		
		if (parts.length === 2 && parts[0] === 'united-states') {
			// /country/category
			return `${category}  in United States`;
		}
		
		// /category
		if (parts.length === 1 && category) {
			return `${category}`;
		}

		return "Best Only Fans Creator";
	};

	const getSEOContent = () => {
		const defaultCategory = 'Best Only Fans Creator';

		if (!htmlContent) return {
			title: `${defaultCategory} Apparel | Revv`,
			description: `${defaultCategory.toLowerCase()} content for you from a professional only fans creator.`,
			canonical: window.location.href
		};

		const path = window.location.pathname;
		const parts = path.split('/').filter(Boolean);
		const category = htmlContent.category?.name || defaultCategory;

		// Explicitly check URL patterns from most specific to least specific
		if (parts.length === 4 && htmlContent.city?.city) {
			// /country/state/city/category
			const state = htmlContent.city?.state?.state || htmlContent.state?.state;
			const locationStr = `${htmlContent.city.city}, ${state}`;
			return {
				title: `${category} in ${locationStr} | RevvedNReady`,
				description: `${category.toLowerCase()} in ${locationStr}. RevvedNReady is the best Only Fans Creator for you.`,
				canonical: window.location.href
			};
		}
		
		if (parts.length === 3 && htmlContent.state?.state) {
			// /country/state/category
			return {
				title: `${category} in ${htmlContent.state.state} | RevvedNReady`,
				description: `${category.toLowerCase()} in ${htmlContent.state.state}. RevvedNReady is the best Only Fans Creator for you.`,
				canonical: window.location.href
			};
		}
		
		if (parts.length === 2 && parts[0] === 'united-states') {
			// /country/category
			return {
				title: `${category} in the United States | RevvedNReady`,
				description: `${category.toLowerCase()} in the United States. RevvedNReady is the best Only Fans Creator for you.`,
				canonical: window.location.href
			};
		}
		
		// /category
		return {
			title: `${category} | RevvedNReady`,
			description: `${category.toLowerCase()}. RevvedNReady is the best Only Fans Creator for you.`,
			canonical: window.location.href
		};
	};

	const seoContent = getSEOContent();

	return (
        <div>
            <Helmet>
                <title>{seoContent.title}</title>
                <meta name="description" content={seoContent.description} />
                <link rel="canonical" href={seoContent.canonical} />
                
                {/* Open Graph tags */}
                <meta property="og:title" content={seoContent.title} />
                <meta property="og:description" content={seoContent.description} />
                <meta property="og:url" content={seoContent.canonical} />
                <meta property="og:type" content="website" />
                <meta property="og:site_name" content="RevvedNReady" />
                
                {/* Twitter Card tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={seoContent.title} />
                <meta name="twitter:description" content={seoContent.description} />
            </Helmet>

            <header className={`bg-gradient-to-r from-gray-900 via-black to-gray-800 top-0 z-50 fixed left-0 w-full shadow-lg transition-transform duration-300 border-b border-red-500/20 ${
                isHeaderVisible ? 'translate-y-0' : '-translate-y-full'
            }`}>
                <div className="flex justify-between items-center py-4 px-6">
                    <a href="/" className="flex-shrink-0 flex items-center gap-3">
                        <div className="flex items-center gap-3">
                            <svg width="36" height="36" viewBox="0 0 36 36" className="text-red-500">
                                <defs>
                                    <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#ef4444" />
                                        <stop offset="100%" stopColor="#dc2626" />
                                    </linearGradient>
                                </defs>
                                {/* Automotive-inspired logo design */}
                                <path 
                                    d="M18 3C9.716 3 3 9.716 3 18s6.716 15 15 15 15-6.716 15-15S26.284 3 18 3z" 
                                    fill="none" 
                                    stroke="url(#logoGradient)" 
                                    strokeWidth="2"
                                />
                                {/* Speedometer/gear design */}
                                <path 
                                    d="M18 6C11.373 6 6 11.373 6 18s5.373 12 12 12 12-5.373 12-12S24.627 6 18 6z" 
                                    fill="none" 
                                    stroke="url(#logoGradient)" 
                                    strokeWidth="1.5"
                                />
                                {/* Center gear/speedometer */}
                                <circle cx="18" cy="18" r="4" fill="url(#logoGradient)" />
                                <circle cx="18" cy="18" r="2" fill="white" />
                                {/* Speed lines */}
                                <path d="M8 18h4" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M24 18h4" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M18 8v4" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                <path d="M18 24v4" stroke="url(#logoGradient)" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                            <div className="text-white">
                                <h1 className="text-xl font-bold tracking-wide bg-gradient-to-r from-white to-red-200 bg-clip-text text-transparent">
                                    RevvedNReady
                                </h1>
                                <p className="text-xs text-gray-300 font-light">Premium Automotive Content</p>
                            </div>
            </div>
                    </a>
                    <div className="flex items-center gap-4">
                        <a 
                            className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white text-sm font-bold px-6 py-2 rounded-full flex items-center gap-2 transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105" 
                            href="https://onlyfans.com/bella"
                            target="_blank"
                            rel="noopener"
                        >
                            Join Bella's OnlyFans 
                            <span className="text-red-200">→</span>
                        </a>
                        <div className="hidden md:flex items-center gap-2 text-gray-300 text-sm">
                            <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                            <span>Live Now</span>
                        </div>
                    </div>
                </div>
            </header>
            <div className="" id="">
                {/* Hero Section */}
                <section className="relative min-h-screen flex items-center overflow-hidden">
                    {/* Background Images */}
                    <div className="absolute inset-0">
                        <img 
                            src="/images/home/flag.jpg" 
                            alt="Bella" 
                            className="w-full h-full object-cover"
                        />
                        <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/85 to-black/90"></div>
                    </div>
                    
                    <div className="relative z-10 w-full px-4 pt-24">
                        <div className="max-w-6xl mx-auto">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                                {/* Left Side - Text Content */}
                                <div className="text-white text-center lg:text-left">
                                    <div className="mb-8">
                                        <div className="inline-block bg-gradient-to-r from-red-500/20 to-red-600/20 px-4 py-2 rounded-full border border-red-500/30 mb-6">
                                            <span className="text-red-300 text-sm font-medium">Premium Content Creator</span>
                                        </div>
                                        <h1 className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-white via-red-100 to-white bg-clip-text text-transparent">
                                            {getPageTitle()}
                                        </h1>
                                        <h2 className="text-2xl md:text-3xl font-light text-gray-300 mb-4">
                                            Meet Bella
                                        </h2>
                                        <p className="text-lg text-gray-300 max-w-xl mx-auto lg:mx-0 mb-8 leading-relaxed">
                                            Hey there! I'm Bella, and I love sharing my passion for cars and racing with you. 
                                            Join my OnlyFans to see exclusive content where I combine my love for automotive culture with intimate moments.
                                        </p>
                                    </div>
                                    
                                    <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start items-center mb-12">
                                        <a 
                                            href="https://onlyfans.com/bella"
                                            target="_blank"
                                            rel="noopener"
                                            className="group bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105 flex items-center gap-3"
                                        >
                                            <span className="text-xl">👀</span>
                                            Connect With Me
                                            <span className="group-hover:translate-x-1 transition-transform">→</span>
                                        </a>
                                        <a 
                                            href="#preview"
                                            className="group border-2 border-red-500/50 hover:border-red-500 text-red-300 hover:text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:bg-red-500/10 flex items-center gap-3"
                                        >
                                            <span className="text-xl">💎</span>
                                            Preview Content
                                        </a>
                                    </div>
                                    
                                    <div className="flex justify-center lg:justify-start items-center gap-8 text-gray-400">
                                        <div className="text-center">
                                            <div className="text-2xl font-bold text-red-400">Local</div>
                                            <div className="text-sm">Creator</div>
                                        </div>
                                        <div className="w-px h-12 bg-gray-600"></div>
                                        <div className="text-center">
                                            <div className="text-2xl font-bold text-red-400">4.9★</div>
                                            <div className="text-sm">Rating</div>
                                        </div>
                                        <div className="w-px h-12 bg-gray-600"></div>
                                        <div className="text-center">
                                            <div className="text-2xl font-bold text-red-400">24/7</div>
                                            <div className="text-sm">Access</div>
                                        </div>
                                    </div>
            </div>

                                {/* Right Side - Featured Images */}
                                <div className="grid grid-cols-2 gap-4">
                                    <div className="space-y-4">
                                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                                            <img 
                                                src="/images/home/904F1292-0660-4ABD-B804-E564EA7F0835.jpeg" 
                                                alt="Bella" 
                                                className="w-full h-64 object-cover hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                            <div className="absolute bottom-4 left-4 text-white">
                                                <p className="text-sm font-semibold">Exclusive Content</p>
            </div>
                    </div>
                                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                                            <img 
                                                src="/images/home/ACC4E797-26D8-4190-9D9A-6873310507DE.jpg" 
                                                alt="Bella" 
                                                className="w-full h-48 object-cover hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                            <div className="absolute bottom-4 left-4 text-white">
                                                <p className="text-sm font-semibold">Premium Access</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="space-y-4 pt-8">
                                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                                            <img 
                                                src="/images/home/dsc_8961 copy.jpg" 
                                                alt="Bella" 
                                                className="w-full h-48 object-cover hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                            <div className="absolute bottom-4 left-4 text-white">
                                                <p className="text-sm font-semibold">VIP Sessions</p>
                                            </div>
                                        </div>
                                        <div className="relative overflow-hidden rounded-2xl shadow-2xl">
                                            <img 
                                                src="/images/home/595DCC9D-067F-447F-9F95-BC294308E80C.JPEG" 
                                                alt="Bella" 
                                                className="w-full h-64 object-cover hover:scale-110 transition-transform duration-500"
                                            />
                                            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                                            <div className="absolute bottom-4 left-4 text-white">
                                                <p className="text-sm font-semibold">Live Shows</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Featured Gallery Section */}
                <section className="py-20 px-4 bg-gradient-to-b from-black to-gray-900" id="gallery">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                👀 Bella's Exclusive Content
                            </h2>
                            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                                Experience the perfect blend of passion and stunning beauty
                            </p>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
                            {galleryImages.map((image, index) => (
                                index === galleryImages.length ? (
                                    // Upgrade Teaser Card - Last Position
                                    <div key="upgrade" className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer">
                                        <img 
                                            src={galleryImages[0].src} 
                                            alt="Premium Content" 
                                            className="w-full h-64 object-cover blur-md brightness-75"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                            <svg className="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                            </svg>
                                            <h3 className="text-xl font-bold text-white mb-2">Unlock Everything</h3>
                                            <p className="text-sm text-gray-300 mb-4">Join Bella's OnlyFans for uncensored, exclusive content</p>
                                            <a 
                                                href="https://onlyfans.com/bella" 
                        target="_blank" 
                        rel="noopener" 
                                                className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-6 py-3 rounded-full font-bold text-sm transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                                                onClick={(e) => e.stopPropagation()}
                                            >
                                                Upgrade Now
                                            </a>
                                        </div>
                                    </div>
                                ) : (
                                    <div 
                                        key={index}
                                        className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                                        onClick={() => openLightbox(index)}
                                    >
                                        <img 
                                            src={image.src} 
                                            alt={image.title} 
                                            className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                            <div className="absolute bottom-4 left-4 text-white">
                                                <h3 className="text-lg font-bold mb-1">{image.title}</h3>
                                                <p className="text-sm text-gray-300">Click to view</p>
                                            </div>
                                        </div>
                                    </div>
                                )
                            ))}
                            {/* Upgrade Teaser Card - Always at the end */}
                            <div className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer">
                                <img 
                                    src={galleryImages[0].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-xl font-bold text-white mb-2">Unlock Everything</h3>
                                    <p className="text-sm text-gray-300 mb-4">Join Bella's OnlyFans for uncensored, exclusive content</p>
                                    <a 
                                        href="https://onlyfans.com/bella" 
                                        target="_blank" 
                                        rel="noopener"
                                        className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-6 py-3 rounded-full font-bold text-sm transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        Upgrade Now
                                    </a>
                                </div>
                        </div>
                    </div>

                        <div className="text-center">
                            <a 
                                href="https://onlyfans.com/bella"
                                target="_blank"
                                rel="noopener"
                                className="inline-block bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                            >
                                👀 Join Bella's OnlyFans
                            </a>
                        </div>
                    </div>

                    {/* Lightbox Modal */}
                    {lightboxOpen && (
                        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95" onClick={closeLightbox}>
                            <div className="relative max-w-5xl mx-4" onClick={(e) => e.stopPropagation()}>
                                {/* Close Button */}
                                <button 
                                    onClick={closeLightbox}
                                    className="absolute top-0 right-0 z-10 text-white hover:text-red-400 transition-colors p-4"
                                >
                                    <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>

                                {/* Main Image */}
                                <img 
                                    src={galleryImages[lightboxIndex].src} 
                                    alt={galleryImages[lightboxIndex].title}
                                    className="w-full h-auto max-h-[90vh] object-contain rounded-lg"
                                />

                                {/* Image Info */}
                                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/90 to-transparent p-6 rounded-b-lg">
                                    <h3 className="text-2xl font-bold text-white mb-2">{galleryImages[lightboxIndex].title}</h3>
                                    <p className="text-gray-300">{lightboxIndex + 1} of {galleryImages.length}</p>
                                </div>

                                {/* Navigation Arrows */}
                                <button 
                                    onClick={(e) => { e.stopPropagation(); prevImage(); }}
                                    className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                                    </svg>
                                </button>
                                <button 
                                    onClick={(e) => { e.stopPropagation(); nextImage(); }}
                                    className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-3 rounded-full transition-all"
                                >
                                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                    </svg>
                                </button>

                                {/* Social Share Buttons - Top Left */}
                                <div className="absolute top-0 left-0 z-10 flex flex-col gap-2 p-2">
                                    <button 
                                        onClick={(e) => { e.stopPropagation(); shareOnSocial('twitter'); }}
                                        className="bg-blue-500 hover:bg-blue-600 text-white p-2.5 rounded-full transition-all transform hover:scale-110 shadow-lg flex items-center gap-2"
                                        title="Share on Twitter"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                                        </svg>
                                    </button>
                                    <button 
                                        onClick={(e) => { e.stopPropagation(); shareOnSocial('facebook'); }}
                                        className="bg-blue-600 hover:bg-blue-700 text-white p-2.5 rounded-full transition-all transform hover:scale-110 shadow-lg flex items-center gap-2"
                                        title="Share on Facebook"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                                        </svg>
                                    </button>
                                    <button 
                                        onClick={(e) => { e.stopPropagation(); shareOnSocial('whatsapp'); }}
                                        className="bg-green-500 hover:bg-green-600 text-white p-2.5 rounded-full transition-all transform hover:scale-110 shadow-lg flex items-center gap-2"
                                        title="Share on WhatsApp"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
                                        </svg>
                                    </button>
                                    <button 
                                        onClick={(e) => { e.stopPropagation(); shareOnSocial('pinterest'); }}
                                        className="bg-red-600 hover:bg-red-700 text-white p-2.5 rounded-full transition-all transform hover:scale-110 shadow-lg flex items-center gap-2"
                                        title="Share on Pinterest"
                                    >
                                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M12 0C5.373 0 0 5.372 0 12s5.373 12 12 12c5.302 0 9.925-3.046 11.233-7.494h-5.445c-.799 2.162-2.674 3.507-4.785 3.507-3.18 0-5.754-2.613-5.754-5.836 0-3.897 2.774-7.302 6.55-7.302 3.691 0 5.349 2.424 5.349 5.633 0 3.055-1.402 5.645-4.027 5.645-1.35 0-2.262-.645-2.262-1.571 0-1.373 1.029-2.414 2.32-3.045.81-.37 1.178-.577 1.178-1.091 0-.938-1.192-1.847-3.089-1.847-2.392 0-3.889 1.65-3.889 3.828 0 1.463.593 2.728 1.675 3.206.179.084.31.057.414-.102l.471-1.885c.155-.553.097-.754-.289-1.311C8.548 11.583 8.1 10.1 8.1 8.723c0-2.958 2.072-5.857 6.355-5.857 3.411 0 5.505 2.314 5.505 5.397 0 3.714-2.048 6.744-5.062 6.744-1.524 0-2.95-.824-3.534-1.951l-.89 3.666c-.29 1.131-.906 2.518-1.35 3.379C3.99 19.829 2.411 16.016 2.411 12.001 2.412 5.391 6.6.158 12 .158S21.589 5.39 21.589 12c0 6.609-4.189 11.842-9.589 11.842z"/>
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </section>

                {/* Behind the Scenes Section */}
                <section 
                    className="py-20 px-4 relative overflow-hidden bg-gradient-to-b from-black to-gray-900"
					id="behind-the-scenes"
                >
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                👀 Behind the Scenes
                            </h2>
                            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                                Get exclusive access to Bella's premium content and behind-the-scenes moments
                            </p>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                            <a 
                                href="https://onlyfans.com/bella" 
                        target="_blank" 
                        rel="noopener" 
                                className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[0].src} 
                                    alt="Premium Content" 
                                    className="w-full h-96 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-16 h-16 text-red-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                                    </svg>
                                    <h3 className="text-3xl font-bold text-white mb-3">Exclusive Content</h3>
                                    <p className="text-lg text-gray-300 mb-6">Watch Bella's exclusive videos and intimate moments</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25">
                                        Unlock Now →
                                    </span>
                                </div>
                            </a>

                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-2xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[1].src} 
                                    alt="Premium Content" 
                                    className="w-full h-96 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-16 h-16 text-red-400 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                        </svg>
                                    <h3 className="text-3xl font-bold text-white mb-3">Custom Requests</h3>
                                    <p className="text-lg text-gray-300 mb-6">Get personalized content tailored just for you</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-3 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25">
                                        Unlock Now →
                                    </span>
                                </div>
                    </a>
                </div>
                        
                        <div className="text-center">
                            <a 
                                href="https://onlyfans.com/bella"
                                target="_blank"
                                rel="noopener"
                                className="inline-block bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-12 py-4 rounded-full font-bold text-xl transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                            >
                                👀 Join Bella's OnlyFans
                            </a>
                        </div>
                    </div>
                </section>

                {/* Exclusive Content Section */}
                <section 
                    className="py-20 px-4 relative overflow-hidden"
                        style={{
                        backgroundImage: 'url(/images/home/lambo.jpg)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundAttachment: 'fixed'
                    }}
                >
                    <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/70 to-black/85"></div>
                    <div className="max-w-7xl mx-auto relative z-10">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                🔥 Exclusive Content
                            </h2>
                            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                                Join Bella's exclusive community for premium automotive content
                            </p>
                        </div>
                        
                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                            <a 
                                href="https://onlyfans.com/bella" 
                        target="_blank" 
                        rel="noopener" 
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[0].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                                    <h3 className="text-xl font-bold text-white mb-2">VIP Access</h3>
                                    <p className="text-sm text-gray-300 mb-4">Exclusive Bella content</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-full font-bold text-sm transition-all duration-300">
                                        Unlock Now
                                    </span>
                                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[1].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-xl font-bold text-white mb-2">Night Sessions</h3>
                                    <p className="text-sm text-gray-300 mb-4">Intimate after-dark content</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-full font-bold text-sm transition-all duration-300">
                                        Unlock Now
                                    </span>
                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[2].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-6">
                                    <svg className="w-12 h-12 text-red-400 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-xl font-bold text-white mb-2">Track Days</h3>
                                    <p className="text-sm text-gray-300 mb-4">High-energy adventures</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-full font-bold text-sm transition-all duration-300">
                                        Unlock Now
                                    </span>
                                </div>
                            </a>
                        </div>

                        <div className="text-center">
                            <a 
                                href="https://onlyfans.com/bella"
                                target="_blank"
                                rel="noopener"
                                className="inline-block bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-10 py-4 rounded-full font-bold text-xl transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                            >
                                👀 Join Bella's OnlyFans
                            </a>
                        </div>
                    </div>
                </section>

                {/* Bio Section */}
                <section className="py-20 px-4 bg-gradient-to-b from-black to-gray-900" id="meet-bella">
                    <div className="max-w-6xl mx-auto">
                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                            <div className="order-2 lg:order-1">
                                <div className="relative">
                                    <img 
                                        src="/images/home/img_3990.jpg" 
                                        alt="Bella" 
                                        className="w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent rounded-2xl"></div>
                                </div>
                            </div>
                            
                            <div className="order-1 lg:order-2 text-white">
                                <h2 className="text-4xl md:text-5xl font-bold mb-6">
                                    Meet <span className="text-red-400">Bella</span>
                                </h2>
                                <div className="space-y-6 text-lg text-gray-300 leading-relaxed">
                                    <p>
                                        Welcome to <span className="text-red-400 font-semibold">RevvedNReady</span>, where automotive passion meets stunning beauty. 
                                        I'm Bella, and I've created this exclusive space for those who appreciate the perfect blend of 
                                        high-performance machines and captivating elegance.
                                    </p>
                                    <p>
                                        With over 500K followers and a 4.9-star rating, I've built a community that celebrates both 
                                        the raw power of automotive engineering and the sophisticated beauty that complements it. 
                                        My content combines my love for cars with my passion for creating premium, intimate experiences.
                                    </p>
                                    <p>
                                        Join me in <span className="text-red-400 font-semibold">Bella's Garage</span> for exclusive content, 
                                        behind-the-scenes access, and intimate moments that you won't find anywhere else. 
                                        Whether you're here for the cars, the beauty, or both - you're in the right place.
                                    </p>
                                </div>
                                
                                <div className="mt-8 flex flex-col sm:flex-row gap-4">
                                    <a 
                                        href="https://onlyfans.com/bella"
                        target="_blank" 
                        rel="noopener" 
                                        className="bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105 text-center"
                                    >
                                        👀 Join My OnlyFans
                                    </a>
                                    <a 
                                        href="#contact"
                                        className="border-2 border-red-500/50 hover:border-red-500 text-red-300 hover:text-white px-8 py-4 rounded-full font-bold text-lg transition-all duration-300 hover:bg-red-500/10 text-center"
                                    >
                                        💌 Contact Me
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Geo-Targeted Section */}
                <section className="py-20 px-4 bg-gradient-to-b from-gray-900 to-black">
                    <div className="max-w-7xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                👀 {getPageTitle()}
                            </h2>
                            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                                {htmlContent?.city?.city ? 
                                    `Discover Bella's exclusive OnlyFans content in ${htmlContent.city.city}` :
                                    htmlContent?.state?.state ?
                                    `Experience premium OnlyFans lifestyle in ${htmlContent.state.state}` :
                                    "Join Bella's exclusive OnlyFans for premium content"
                                }
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[2].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent">
                                    <div className="absolute bottom-4 left-4 right-4 text-white">
                                        <div className="flex items-center gap-2 mb-2">
                                            <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                                            </svg>
                                            <h3 className="text-xl font-bold">Local Content</h3>
                                        </div>
                                        <p className="text-sm text-gray-200">
                                            {htmlContent?.city?.city ? 
                                                `Exclusive content for ${htmlContent.city.city}` :
                                                "Join for exclusive OnlyFans content"
                                            }
                                        </p>
                                    </div>
                                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[3].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent">
                                    <div className="absolute bottom-4 left-4 right-4 text-white">
                                        <div className="flex items-center gap-2 mb-2">
                                            <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4" />
                                            </svg>
                                            <h3 className="text-xl font-bold">Custom Content</h3>
                                        </div>
                                        <p className="text-sm text-gray-200">
                                            {htmlContent?.state?.state ? 
                                                `Personalized content for ${htmlContent.state.state}` :
                                                "Tailored content just for you"
                                            }
                                        </p>
                                    </div>
                                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[4].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover group-hover:scale-110 transition-transform duration-700"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/60 to-transparent">
                                    <div className="absolute bottom-4 left-4 right-4 text-white">
                                        <div className="flex items-center gap-2 mb-2">
                                            <svg className="w-5 h-5 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                            </svg>
                                            <h3 className="text-xl font-bold">VIP Access</h3>
                                        </div>
                                        <p className="text-sm text-gray-200">
                                            {htmlContent?.city?.city ? 
                                                `Premium ${htmlContent.city.city} experiences` :
                                                "Exclusive access to premium content"
                                            }
                                        </p>
                                    </div>
                                </div>
                            </a>
                        </div>

                        <div className="text-center">
                            <a 
                                href="https://onlyfans.com/bella"
                                target="_blank"
                                rel="noopener"
                                className="inline-block bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 text-white px-10 py-4 rounded-full font-bold text-xl transition-all duration-300 shadow-lg hover:shadow-red-500/25 transform hover:scale-105"
                            >
                                👀 Join Bella's OnlyFans
                            </a>
                        </div>
                    </div>
                </section>

                {/* Category-Specific Section */}
                <section className="py-20 px-4 bg-gradient-to-b from-gray-900 to-black">
                    <div className="max-w-6xl mx-auto">
                        <div className="text-center mb-16">
                            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
                                🔥 {htmlContent?.category?.name || 'Premium'} Content
                            </h2>
                            <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                                {htmlContent?.category?.name ? 
                                    `Experience the best ${htmlContent.category.name.toLowerCase()} content with Bella` :
                                    "Discover Bella's premium automotive lifestyle content"
                                }
                            </p>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[3].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-4">
                                    <svg className="w-10 h-10 text-red-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                                    <h3 className="text-lg font-bold text-white mb-1">Daily Content</h3>
                                    <p className="text-xs text-gray-300 mb-2">Fresh automotive lifestyle</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-1.5 rounded-full font-bold text-xs transition-all duration-300">
                                        Unlock Now
                                    </span>
                                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[4].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-4">
                                    <svg className="w-10 h-10 text-red-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-lg font-bold text-white mb-1">Exclusive Access</h3>
                                    <p className="text-xs text-gray-300 mb-2">Members-only content</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-1.5 rounded-full font-bold text-xs transition-all duration-300">
                                        Unlock Now
                                    </span>
                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[5].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-4">
                                    <svg className="w-10 h-10 text-red-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-lg font-bold text-white mb-1">Live Sessions</h3>
                                    <p className="text-xs text-gray-300 mb-2">Interactive automotive chats</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-1.5 rounded-full font-bold text-xs transition-all duration-300">
                                        Unlock Now
                                    </span>
                                </div>
                            </a>
                            
                            <a 
                                href="https://onlyfans.com/bella" 
                                target="_blank" 
                                rel="noopener"
                                className="group relative overflow-hidden rounded-xl shadow-2xl transform hover:scale-105 transition-all duration-500 cursor-pointer"
                            >
                                <img 
                                    src={galleryImages[6].src} 
                                    alt="Premium Content" 
                                    className="w-full h-64 object-cover blur-md brightness-75"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/90 flex flex-col items-center justify-center text-center p-4">
                                    <svg className="w-10 h-10 text-red-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                                    </svg>
                                    <h3 className="text-lg font-bold text-white mb-1">Custom Requests</h3>
                                    <p className="text-xs text-gray-300 mb-2">Personalized content</p>
                                    <span className="bg-gradient-to-r from-red-500 to-red-600 text-white px-4 py-1.5 rounded-full font-bold text-xs transition-all duration-300">
                                        Unlock Now
                                    </span>
                                </div>
                            </a>
                        </div>
                    </div>
                </section>

            </div>

            {/* Navigation Pills Section */}
            <section className="py-16 px-4 bg-gradient-to-b from-gray-800 to-black">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl md:text-4xl text-white text-center mb-4 font-bold">
					{window.location.pathname.includes('/united-states') 
                            ? "👀 Coming to a city near you!" 
                            : "👀 Explore Bella's Content"}
				</h2>
                    <p className="text-gray-400 text-center mb-12 max-w-2xl mx-auto">
                        Discover premium OnlyFans content tailored to your location
                    </p>
                    <div className="flex flex-wrap justify-center gap-4">
					{getNavigationItems().map((item, index) => (
						<a
							key={index}
							href={item.slug}
                                className="group inline-block px-6 py-3 rounded-full bg-gradient-to-r from-red-500/20 to-red-600/20 hover:from-red-500/30 hover:to-red-600/30 
                                text-red-300 hover:text-white transition-all duration-300 text-sm font-medium shadow-lg 
                                hover:shadow-red-500/25 transform hover:-translate-y-1 border border-red-500/30 hover:border-red-500/50"
						>
							{item.name}
						</a>
					))}
                    </div>
				</div>
			</section>

            {/* Footer */}
            <footer className="bg-black py-16 px-4">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
                        {/* Brand Section */}
                        <div className="lg:col-span-2">
                            <div className="flex items-center gap-3 mb-6">
                                <svg width="40" height="40" viewBox="0 0 40 40" className="text-red-500">
                                    <defs>
                                        <linearGradient id="footerLogoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                            <stop offset="0%" stopColor="#ef4444" />
                                            <stop offset="100%" stopColor="#dc2626" />
                                        </linearGradient>
                                    </defs>
                                    <path 
                                        d="M20 3C10.611 3 3 10.611 3 20s7.611 17 17 17 17-7.611 17-17S29.389 3 20 3zm0 30C12.268 30 6 23.732 6 16S12.268 2 20 2s14 6.268 14 14-6.268 14-14 14z" 
                                        fill="none" 
                                        stroke="url(#footerLogoGradient)" 
                                        strokeWidth="2"
                                    />
                                    <path 
                                        d="M20 6C12.268 6 6 12.268 6 20s6.268 14 14 14 14-6.268 14-14S27.732 6 20 6z" 
                                        fill="none" 
                                        stroke="url(#footerLogoGradient)" 
                                        strokeWidth="1.5"
                                    />
                                    <circle cx="20" cy="20" r="4" fill="url(#footerLogoGradient)" />
                                    <circle cx="20" cy="20" r="2" fill="white" />
                                    <path d="M9 20h4" stroke="url(#footerLogoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                    <path d="M27 20h4" stroke="url(#footerLogoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                    <path d="M20 9v4" stroke="url(#footerLogoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                    <path d="M20 27v4" stroke="url(#footerLogoGradient)" strokeWidth="2" strokeLinecap="round"/>
                                </svg>
                                <div>
                                    <h3 className="text-2xl font-bold text-white">RevvedNReady</h3>
                                    <p className="text-gray-400 text-sm">Bella's Exclusive Content</p>
                                </div>
                            </div>
                            <p className="text-gray-400 mb-6 max-w-md">
                                Experience the perfect blend of automotive passion and stunning beauty. 
                                Join Bella's exclusive community for premium content that's both sexy and sophisticated.
                            </p>
                            <div className="flex gap-4">
                                <a href="#" className="text-gray-400 hover:text-red-400 transition-colors">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                                    </svg>
                                </a>
                                
                                <a href="#" className="text-gray-400 hover:text-red-400 transition-colors">
                                    <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                                    </svg>
                                </a>
                                
                            </div>
                        </div>

                        {/* Quick Links */}
                        <div>
                            <h4 className="text-white font-bold text-lg mb-4">About</h4>
                            <ul className="space-y-3">
							<li><a href="/" className="text-gray-400 hover:text-red-400 transition-colors">Home</a></li>
                                <li><a href="/#meet-bella" className="text-gray-400 hover:text-red-400 transition-colors">About Bella</a></li>
                                <li><a href="/#behind-the-scenes" className="text-gray-400 hover:text-red-400 transition-colors">Behind Scenes</a></li>
                                
                            </ul>
                        </div>

                        {/* Content Categories */}
                        <div>
                            <h4 className="text-white font-bold text-lg mb-4">Content</h4>
                            <ul className="space-y-3">
                                <li><a href="https://onlyfans.com/bella" target="_blank" rel="noopener" className="text-gray-400 hover:text-red-400 transition-colors">VIP Access</a></li>
                                <li><a href="https://onlyfans.com/bella" target="_blank" rel="noopener" className="text-gray-400 hover:text-red-400 transition-colors">Exclusive Content</a></li>
                                <li><a onClick={() => scrollToSection('behind-the-scenes')} className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer">Behind Scenes</a></li>
                                <li><a onClick={() => scrollToSection('gallery')} className="text-gray-400 hover:text-red-400 transition-colors cursor-pointer">Gallery</a></li>
                            </ul>
                        </div>
                    </div>

                    {/* Bottom Footer */}
                    <div className="border-t border-gray-800 pt-8">
                        <div className="flex flex-col md:flex-row justify-between items-center">
                            <div className="text-gray-400 text-sm mb-4 md:mb-0">
                                © 2024 RevvedNReady. All rights reserved. Bella's exclusive content platform.
                            </div>
                            <div className="flex gap-6 text-sm">
                                <a href="#privacy" className="text-gray-400 hover:text-red-400 transition-colors">Privacy Policy</a>
                                <a href="#terms" className="text-gray-400 hover:text-red-400 transition-colors">Terms of Service</a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
            
        </div>
    );
};

export default PageRenderer;